import { Injectable, Injector } from '@angular/core';

import { SessionService } from './session.service';
import { SummaryService } from './summary.service';
import { BaseReportService } from './reportBase.service';
import type { IGetReportData, ISummaryCustomerDoc, TReportOptions } from '@shared/models';
import { Constants } from '@shared/models';
const DateTimeFormats = Constants.DateTimeFormats;

@Injectable()
export class ReportCustomerSummaryService extends BaseReportService implements IGetReportData {
    private sessionService: SessionService;
    private summaryService: SummaryService;

    constructor(injector: Injector) {
        super(injector);
        this.sessionService = injector.get(SessionService);
        this.summaryService = injector.get(SummaryService);
    }

    public async getReportData(): Promise<any> {
        const startingDate = this.options.startingDate;
        const endingDate = this.options.endingDate;
        const allRows: any[] = [];
        // let totalCustomers = 0;
        let reportColValues: string[];
        let rowInfo: any;

        const summary = await this.summaryService.getByUid('customersSummary') as ISummaryCustomerDoc;
        const dailyValues = summary.dailyValues;

        dailyValues.forEach((daily) => {
            const count = daily.count;
            const isoString = this.dateService.formatTimestamp(daily.date, 'iso')
            const timestamp = this.dateService.parse(isoString, 'iso'); //  DateTimeFormats.ShortDate);
            // .formatDateTime(campaign.sentDate);
            const date = this.formatDateTime(timestamp, DateTimeFormats.MediumDate);

            reportColValues = [date, count.toString()];
            rowInfo = this.buildRowInfo(reportColValues, 'data');
            allRows.push(rowInfo);

            // totalCustomers += count;
        });

        // Now show a blank row.
        reportColValues = [' ', ' ', ' '];
        rowInfo = this.buildRowInfo(reportColValues, 'data');
        allRows.push(rowInfo);

        // Show the summary row.
        reportColValues = ['Summary:', ' ', ' '];
        rowInfo = this.buildRowInfo(reportColValues, 'summary');
        allRows.push(rowInfo);

        // End of report data
        allRows.push(undefined);
        const reportData = { 'data': allRows };
        return reportData;
    }

    // private addSummaryRow(columns, allRows) {
    //     const rowInfo = super.buildRowInfo(columns, 'summary');
    //     allRows.push(rowInfo);
    // }
}
